import script from "./PageTop.vue?vue&type=script&setup=true&lang=js"
export * from "./PageTop.vue?vue&type=script&setup=true&lang=js"

import "./PageTop.vue?vue&type=style&index=0&id=a329e6c4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a329e6c4"]])

export default __exports__